import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import breakpoints from 'rp-mq-breakpoints';
import Svg from 'rp-react-svg-icon';

class TableError extends PureComponent {
    static propTypes = {
        children: PropTypes.string,
        size: PropTypes.number,
        colSpanGetter: PropTypes.func
    };

    static get defaultProps() {
        return {
            colSpanGetter(breakpoint, size) {
                return size;
            }
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            colSpan: this.props.colSpanGetter(breakpoints.current().code, this.props.size)
        };
        this.handleBreakpointsSwitch = this.handleBreakpointsSwitch.bind(this);
    }

    componentDidMount() {
        global.addEventListener('rpBreakpointsSwitch', this.handleBreakpointsSwitch);
    }

    componentWillUnmount() {
        global.removeEventListener('rpBreakpointsSwitch', this.handleBreakpointsSwitch);
    }

    handleBreakpointsSwitch(event) {
        this.setState({
            colSpan: this.props.colSpanGetter(event.detail.breakpoint.code, this.props.size)
        });
    }

    render() {
        return (
            <tr>
                <td
                    className="ui-table__cell ui-table__cell_errorMessage"
                    colSpan={this.state.colSpan}
                >
                    <div className="ui-errorMessage">
                        <div className="ui-errorMessage__icon">
                            <Svg size="XL" iconName="results" />
                        </div>
                        <div className="ui-errorMessage__text">{this.props.children}</div>
                    </div>
                </td>
            </tr>
        );
    }
}

export default TableError;



// WEBPACK FOOTER //
// ./src/js/modules/DataTable/components/TableError.js